import React, { useState } from 'react';
import { setLocalActiveClass } from "../../../utils/helper";
import './5mmguide.scss';
import { Scrollbars } from "react-custom-scrollbars";
import HomeSideMenu from '../../../components/homesidebar/homesidebar'
import HomeHeader from '../../../components/homeheader/homeheader';

class FiveMMGuide extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showToast: true,
            setModalShow: false,
            modalShow: false,

        }
        setLocalActiveClass("HomeInstructions")
    }
    onGoClick() {
        this.props.history.push('/setreminder')
    }



    render() {
        const { modalShow, setModalShow } = this.state
        return (
            <div className='main-5mmGuide'>
                <HomeSideMenu {...this.props}></HomeSideMenu>
                <HomeHeader></HomeHeader>
                <div className='inner-5mmGuide'>
                    <Scrollbars className='home-Scroll'>
                        <div className='main-Container'>
                            <div>Read More 5MM</div>
                        </div>
                    </Scrollbars>
                </div>
            </div>
        )
    }
}




export default FiveMMGuide;

